import React from "react";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";

const DUTable = ({
  tbData,
  isPage,
  setIsPage,
  pagination,
  dietUnitColumns,
}) => {
  return (
    <div className="fullWidthFlexCenter mt30 overflowAuto separatedTable">
      <PaymentLinkTable
        tableData={tbData}
        tableColumns={dietUnitColumns}
        tablePagination={pagination}
        isPage={isPage}
        setIsPage={(value) => setIsPage(value)}
      />
    </div>
  );
};

export default DUTable;
